import { render, staticRenderFns } from "./SelectTiersComponent.vue?vue&type=template&id=808b9566"
import script from "./SelectTiersComponent.vue?vue&type=script&lang=js"
export * from "./SelectTiersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports